import { useEffect } from "react";

const SITE = "Practical AI for Everyday Life";
const DEFAULT_IMAGE = "/brand/bj-banner.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Centralized SEO: title, description, canonical, Open Graph, Twitter, JSON-LD.
export function useSeo({ title, description, image, type = "website", canonical, jsonLd } = {}) {
  const jsonKey = JSON.stringify(jsonLd || null);
  useEffect(() => {
    const origin = window.location.origin;
    const url = canonical || origin + window.location.pathname;
    const img = image ? (image.startsWith("http") ? image : origin + image) : origin + DEFAULT_IMAGE;
    const ttl = title || SITE;

    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    upsertMeta("property", "og:site_name", SITE);
    upsertMeta("property", "og:title", ttl);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", ttl);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    const ATTR = "data-seo-jsonld";
    document.head.querySelectorAll(`script[${ATTR}]`).forEach((n) => n.remove());
    if (jsonLd) {
      const arr = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      arr.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute(ATTR, "true");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
    return () => {
      document.head.querySelectorAll(`script[${ATTR}]`).forEach((n) => n.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, image, type, canonical, jsonKey]);
}
